export default () => {
  // 定义一个关闭页面的函数
  const closePage = () => {
    KNB.use('closePage', {})
  }

  // 使用 KNB 登录功能
  KNB.use('login', {
    // 登录成功的回调函数
    success: (user) => {
      // 如果用户有 token，则刷新页面
      if (user?.token) {
        window.location.reload()
        return
      }
      // 否则，关闭页面
      closePage()
    },
    // 登录失败的回调函数
    fail: () => {
      // 关闭页面
      closePage()
    },
  })
}
